import { createIcon } from "../create-icon"

export const NextIcon = createIcon({
  title: "NextIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.7004 4.23966C5.41855 4.5432 5.43613 5.01775 5.73966 5.2996L8.64779 8L5.73966 10.7004C5.43613 10.9823 5.41855 11.4568 5.7004 11.7603C5.98226 12.0639 6.45681 12.0815 6.76034 11.7996L10.2603 8.5496C10.4132 8.40769 10.5 8.20856 10.5 8C10.5 7.79145 10.4132 7.59232 10.2603 7.45041L6.76034 4.20041C6.45681 3.91856 5.98226 3.93613 5.7004 4.23966Z"
      fill="currentColor"
    />
  ),
})

NextIcon.displayName = "NextIcon"
